/* eslint-disable react/button-has-type */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { CSSProperties } from 'react';
import { colors, effects } from '../../theme';
import merge from 'lodash/merge';
import { onMd, onSm } from '../../styles/responsive';

const defaultRootCss: any = {
  backgroundColor: '#00828b !important',
  backgroundImage: 'linear-gradient(to right, #00828b 0%, #56998b 40%, #00828b 100%)',
  transition: '0.5s',
  backgroundSize: '200% auto',
  borderImageSlice: 1,
  borderRadius: '8px',
  padding: '0px 28px !important',
  display: 'flex',
  width: '140px',
  justifyContent: 'center',
  border: 'none',
  alignItems: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
  // margin: 0,

  '&:hover': {
    ...effects.glow
  },
  [onMd]: {
    height: '36px'
  },
  [onSm]: {
    height: '34px'
  }
};

export const SolidGradientLink = ({
  text,
  url,
  rootCss
}: {
  text: string;
  url: string;
  rootCss: Record<string, any>;
}) => {
  return (
    <a css={merge({ ...defaultRootCss, margin: '0px' }, rootCss || ({} as CSSProperties))} href={url}>
      <p
        css={{
          margin: 0,
          textAlign: 'center',
          fontWeight: 500,
          color: colors.font
        }}
      >
        {text}
      </p>
    </a>
  );
};

export const SolidGradientButton = ({
  text,
  rootCss,
  onClick,
  type
}: {
  type?: 'button' | 'reset' | 'submit';
  text: string;
  rootCss: Record<string, any>;
  onClick: (...props: any[]) => any;
}) => {
  return (
    <button type={type || 'button'} onClick={onClick} css={merge(defaultRootCss, rootCss || ({} as CSSProperties))}>
      <p
        css={{
          margin: 0,
          fontFamily: 'Roboto',
          textAlign: 'center',
          fontWeight: 500,
          border: 'none',
          fontSize: '14px',
          color: colors.font
        }}
      >
        {text}
      </p>
    </button>
  );
};
